import PropTypes from 'prop-types';

import Icon from '../../../atoms/icon';
import format from '../../../../utils/format';
import styles from './morningstar-rating-row.module.scss';
import { augmentClassName } from '../../../../utils/GlobalCssProxy';

const className = augmentClassName(styles);

const RatingRow = ({ outOfFunds, rating, category }) => {
  const hasRating = typeof rating === 'number';
  return (
    <div {...className('placement', 'd-print-none')}>
      <div {...className('format')}>
        <span {...className('sr-only')}>
          {rating >= 1 && rating <= 5
            ? `${format.number(rating, { formatString: '0' })} out of 5 stars`
            : 'Rating Unavailable'}
        </span>
        {hasRating ? (
          <span aria-hidden="true" {...className('stars')}>
            {[1, 2, 3, 4, 5].map(ordinal => (
              <Icon.Star key={ordinal} {...className(ordinal > rating && 'text-light', ordinal > rating && 'opacity-50', 'mr-2')} />
            ))}
          </span>
        ) : (
          <span {...className('n-a-text')}>N/A</span>
        )}
      </div>
      {hasRating && (
        <div {...className('format', 'ratings-out-of')}>
          Out of {format.number(outOfFunds, {
            formatString: '0,0'
          })} Funds
        </div>
      )}
      {category && <div {...className('format', 'category')}> {category} </div>}
    </div>
  );
};

RatingRow.propTypes = {
  outOfFunds: PropTypes.number,
  rating: PropTypes.oneOf([0, 1, 2, 3, 4, 5]),
  category: PropTypes.string
};

export default RatingRow;
